import { __exports as pharmacode } from "./index180.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredPharmacode;
function requirePharmacode() {
  if (hasRequiredPharmacode) return pharmacode;
  hasRequiredPharmacode = 1;
  Object.defineProperty(pharmacode, "__esModule", {
    value: true
  });
  pharmacode.pharmacode = void 0;
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var pharmacode$1 = (function(_Barcode) {
    _inherits(pharmacode2, _Barcode);
    function pharmacode2(data, options) {
      _classCallCheck(this, pharmacode2);
      var _this = _possibleConstructorReturn(this, (pharmacode2.__proto__ || Object.getPrototypeOf(pharmacode2)).call(this, data, options));
      _this.number = parseInt(data, 10);
      return _this;
    }
    _createClass(pharmacode2, [{
      key: "encode",
      value: function encode() {
        var z = this.number;
        var result = "";
        while (!isNaN(z) && z != 0) {
          if (z % 2 === 0) {
            result = "11100" + result;
            z = (z - 2) / 2;
          } else {
            result = "100" + result;
            z = (z - 1) / 2;
          }
        }
        result = result.slice(0, -2);
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function valid() {
        return this.number >= 3 && this.number <= 131070;
      }
    }]);
    return pharmacode2;
  })(_Barcode3.default);
  pharmacode.pharmacode = pharmacode$1;
  return pharmacode;
}
export {
  requirePharmacode as __require
};
//# sourceMappingURL=index144.js.map
